import * as styles from './styles/styles.module.scss';

type CultureStatProps = {
  title: string;
  subtitle: string;
};

const CultureStat = ({ title, subtitle }: CultureStatProps): JSX.Element => (
  <div className={styles.stat}>
    <div className={styles.title}>{title}</div>
    <div className={styles.subtitle}>{subtitle}</div>
  </div>
);

export { CultureStat as default, CultureStatProps };
